const dropdown = document.querySelector('.expertise-actions');

if (dropdown) {
    const dropdownItems = dropdown.querySelectorAll('.expertise-item');
    const locationDetail = document.querySelector('.recruiter-details');

    // Add a click event listener to the dropdown header
    dropdown.querySelector('.button--primary').addEventListener('click', function () {
        dropdown.classList.toggle('open');
    });

    // Add click event listeners to the dropdown items
    dropdownItems.forEach(function (item) {
        item.addEventListener('click', function () {
            const selectedValue = item.getAttribute('data-value');

            // Hide all location divs
            locationDetail.querySelectorAll('.recruiter').forEach(function (location) {
                location.classList.add('hidden');
            });

            // Show the location div corresponding to the selected item
            const selectedLocation = document.getElementById(selectedValue + 'recruiter');
            if (selectedLocation) {
                selectedLocation.classList.remove('hidden');
            }

            // Update the dropdown text
            dropdown.querySelector('.font-text-s').textContent = item.textContent;

            dropdownItems.forEach(function (item) {
                if (item.classList.contains('selected')) {
                    item.classList.remove('selected');
                }
            });

            // Update the new dropdown list
            item.classList.add('selected');

            // Close the dropdown
            dropdown.classList.remove('open');
        });
    });
}
